/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Button, Icon, message, Table, Popconfirm, Empty } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Query, graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { RoleCode } from '../../../constants'
import { getAge } from '../../../constants/helper'

import ConstituentAvatar from '../../../components/Custom/ConstituentAvatar'
import ViewDetails from '../../Certificates/modalDetails'
import AddForm from './addForm'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			page: 1,
			pageSize: 10,
			searchText: '',
			sortOrder: null,
			sortName: null,
			isAddFormShown: false,
			isViewDetailsShown: false,
			isEdit: false,
			selectedConstituent: null,
			isGenerating: false
		}
        
		this.handleOnChange = this.handleOnChange.bind(this)
	}
    
	handleOnChange(pagination, filters, sorter) {
		this.setState({
			page: pagination.current,
			pageSize: pagination.pageSize,
			sortOrder: (sorter.order === 'ascend') ? 'asc' : 'desc',
			sortName: sorter.field,
			// reservation_status: filters.status,
		})
	}

	render() {
		const { AuthStore, household = null } = this.props
		const { barangay_uid, user_type } = AuthStore
		const { page, pageSize, sortOrder, sortName, searchText,
			isAddFormShown, isEdit, selectedConstituent, isViewDetailsShown,
			isGenerating
		} = this.state
		const filters = { 
			page, pageSize, searchText, sortOrder, sortName
		}
		const isAdmin = (_.isEqual(user_type, RoleCode.SYSTEMADMIN) || _.isEqual(user_type, RoleCode.SUPERADMIN))
		
		return (
			<Row type='flex' justify='center'>
				<Col md={24} sm={24}>
					<Row>
						<button type="button" className="btn btn-primary btn-rounded waves-effect waves-light" onClick={() => {
							this.setState({ isAddFormShown: true, isEdit: false, selectedConstituent: null })
						}} style={{ float: 'right' }}>
							{
								(!household) ? 'Add New Constituent' : 'Add Household Member'
							}
						</button>
						<Input placeholder='Search Here' style={{ width: 230, float: 'right', marginRight: 20, marginTop: 5 }} onChange={(e) => {
							this.setState({ searchText: e.target.value })
						}}/>
					</Row>
					<br />
					<Row>
						<Query 
							query={BARANGAY_CONSTITUENTS} 
							variables={{ 
								searchFilter: filters, 
								barangay_uid, 
								household_uid: _.has(household, 'uid') ? household.uid : null 
							}}
							fetchPolicy='network-only'
						>
							{({ loading, error, data }) => {
								if (error) return <Empty/>

								let constituents = _.has(data,'allBarangayConstituents') ? data.allBarangayConstituents.data : []
								constituents = constituents.map((constituent, key) => Object.assign({}, constituent, { key }))
								let _pagination = _.has(data, 'allBarangayConstituents') ? data.allBarangayConstituents.pagination : {}
								_pagination = Object.assign({}, _pagination, {
									pageSizeOptions: ['10', '25', '50'],
									showSizeChanger: true,
									total: _.has(_pagination, 'rowCount') ? _pagination.rowCount : 0,
									showTotal: (total) => `Total ${total} items`
								})

								let columns = [
									{
									 	title: '#',
									 	key: 'avatar',
										width: 110,
										align: 'center',
									 	render: (record) => {
											 return <ConstituentAvatar size={60} constituent_uid={record.uid} />
										}
									}, {
									 	title: 'ID Number',
									 	key: 'id',
									 	width: 100,
										render: (item) => {
											let idNumber = (item.id_number) ? item.id_number : item.id
											return <span>{idNumber}</span>
										}
									}, {
									 	title: 'First Name',
									 	dataIndex: 'first_name',
									 	key: 'first_name',
									 	width: 170
									}, {
										title: 'Middle Name',
										dataIndex: 'middle_name',
										key: 'middle_name',
									 	width: 170
									}, {
										title: 'Last Name',
										dataIndex: 'last_name',
										key: 'last_name',
									 	width: 170
									}, {
										title: 'Household Type',
										dataIndex: 'relation_in_head',
										key: 'relation_in_head',
									 	width: 150
									}, {
										title: 'Gender',
										dataIndex: 'gender',
										key: 'gender',
									 	width: 150
									}, {
										title: 'Birthday',
										key: 'birthday',
									 	width: 150,
										render: (record) => (
											<span>{moment(record.birthday).format('LL')}</span>
										)
									}, {
										title: 'Age',
										key: 'age',
									 	width: 70,
										render: (record) => (
											<span>{getAge(record.birthday)}</span>
										)
									}, {
										title: 'Purok',
										dataIndex: 'purok_name',
										key: 'purok_name',
									 	width: 100
									}, {
										title: 'Block',
										dataIndex: 'block',
										key: 'block',
									 	width: 100
									}, {
										title: 'Action',
										key: 'action',
										width: 200,
										fixed: 'right',
										render: (record) => {
											return (
												<React.Fragment>
													<a href='javascript:void(0)' style={{ cursor: 'pointer', textDecoration: 'underline', marginRight: 10 }} onClick={() => this.setState({ isViewDetailsShown: true, selectedConstituent: record })}>View Details</a>
													<a href='javascript:void(0)' style={{ cursor: 'pointer', textDecoration: 'underline', marginRight: 10 }} onClick={() => this.setState({ isAddFormShown: true, isEdit: true, selectedConstituent: record })}>Edit</a>
													{
														isAdmin &&
														<Popconfirm
															title="Are you sure delete this constituent?"
															onConfirm={() => {
																const { deleteConstituent } = this.props
																deleteConstituent({ constituent_uid: record.uid })
																	.then((response) => {
																		message.success('Constituent successfully deleted.')

																		//create audit trail
																		const auditParams = {
																			module_name: 'Constituent',
																			action: 'Delete',
																			message: `Deleted constituent ${record.first_name} ${record.last_name}`
																		}
																		AuthStore.saveAuditTrail(auditParams)
																	}).catch(err => {
																		console.log('error deleting constituent', err)
																		message.error(err.message.replace('GraphQL error:', ''))
																	})
															}}
															// onCancel={cancel}
															okText="Yes"
															cancelText="No"
														>
															<a href='javascript:void(0)' style={{ cursor: 'pointer', textDecoration: 'underline' }}>Delete</a>
														</Popconfirm>
													}
													<br/>
													<a disabled={isGenerating} href='javascript:void(0)' style={{ cursor: 'pointer', textDecoration: 'underline', color: '#0428a0' }} onClick={() => {
														const { generateID } = this.props

														this.setState({ isGenerating: true }, () => {
															generateID({ constituent_uid: record.uid, barangay_uid })
																.then((response) => {
																	const { file_url } = response.data.generateContituentID
																	window.open(`${process.env.REACT_APP_BACKEND_API}${file_url}`, '_blank')
																	message.success('Constituent ID successfully generated.')
																	this.setState({ isGenerating: false })
																	//create audit trail
																	const auditParams = {
																		module_name: 'Constituent',
																		action: 'Create',
																		message: `Created ID for constituent ${record.first_name} ${record.last_name}`
																	}
																	AuthStore.saveAuditTrail(auditParams)
																}).catch(err => {
																	console.log('error generating id', err)
																	message.error(err.message.replace('GraphQL error:', ''))
																	this.setState({ isGenerating: false })
																})
														})
													}}>Generate ID</a>
												</React.Fragment>
											)
										}
									}]
								if (!household) {
									columns.splice(1, 0, {
										title: 'HH No.',
									 	dataIndex: 'household_no',
									 	key: 'household_no',
									 	width: 100,
										align: 'center'
									})
								}
								return (
									<Table 
										loading={loading}
										columns={columns} 
										dataSource={constituents} 
										bordered
										onChange={this.handleOnChange}
										pagination={_pagination}
										scroll={{ x: 1020 }}
										rowClassName={(record, index) => (record.is_alive == 0) ? 'table-row-deceased' :  ''}
									/>
								)
							}}
						</Query>
					</Row>
					{
						isAddFormShown &&
                        <AddForm
                        	isEdit={isEdit}
                        	selectedConstituent={selectedConstituent}
                        	visible={isAddFormShown}
                        	onClose={() => this.setState({ isAddFormShown: false, isEdit: false, selectedConstituent: null })}
                        	fromHousehold={household}
                        />
					}
					{
						isViewDetailsShown &&
						<ViewDetails 
							constituent_uid={selectedConstituent.uid}
							visible={isViewDetailsShown}
							onCancel={() => this.setState({ isViewDetailsShown: false, selectedConstituent: null })}
						/>
					}
				</Col>
			</Row>
		)
	}
}

const BARANGAY_CONSTITUENTS = gql`
    query allBarangayConstituents($barangay_uid: String, $household_uid: String, $searchFilter: SearchParams) {
		allBarangayConstituents(barangay_uid: $barangay_uid, household_uid: $household_uid, searchFilter: $searchFilter)
    }
`

const DELETE_CONSTITUENT = gql`
    mutation deleteConstituent($input: JSON) {
		deleteConstituent(input: $input)
    }
`

const GENERATE_ID = gql`
    mutation generateContituentID($input: JSON) {
		generateContituentID(input: $input)
    }
`

const composed = compose(
	inject('AuthStore'),
	graphql(DELETE_CONSTITUENT, {
		props({ mutate }) {
			return {
				deleteConstituent(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['allBarangayConstituents']
					})
				}
			}
		}
	}),
	graphql(GENERATE_ID, {
		props({ mutate }) {
			return {
				generateID(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['allBarangayConstituents']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
